// web/src/components/ConfirmDialog.tsx — destructive → danger button; explicit confirm (D05).
import { Modal } from './Modal';

export function ConfirmDialog({ open, title, body, confirmLabel, destructive, onConfirm, onCancel }: {
  open: boolean; title: string; body: string; confirmLabel: string;
  destructive?: boolean; onConfirm(): void; onCancel(): void;
}) {
  return (
    <Modal open={open} onClose={onCancel} title={title} size="sm">
      <p className="text-sm text-muted">{body}</p>
      <div className="mt-5 flex justify-end gap-2">
        <button onClick={onCancel} className="min-h-11 rounded-md border border-hair px-4 text-sm text-ink">Cancel</button>
        <button onClick={onConfirm}
          className={`min-h-11 rounded-md px-4 text-sm font-medium transition-transform active:scale-[0.98] ${destructive ? 'bg-danger text-runink' : 'bg-run text-runink'}`}>
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
